import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { ParishUsersState } from 'types/user';
import { getDefaultCompanyId } from 'utils/helpers';

const initialState: ParishUsersState = {
    records: [],
    loading: false,
    error: null,
};

export const fetchParishUsers = createAsyncThunkWrapper('parishUsers/fetchParishUsers', async (_, { getState }) => {
    const state: any = getState();
    const companyId = getDefaultCompanyId(state);
    const res: any = await client.post('/user/searchUser', {}, { companyId });
    return res?.users || [];
});

const parishUsersSlice = createSlice({
    name: 'parishUsers',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchParishUsers.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchParishUsers.fulfilled, (state, action) => {
            state.loading = false;
            const { payload } = action || {};
            if (!payload) return;
            state.records = payload;
        });
        builder.addCase(fetchParishUsers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
        });
    },
});

export default parishUsersSlice.reducer;
